



























import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import { ShouninTask } from '@/store/types'
import { shouninTaskStore } from '@/store/session/ShouninTaskStoreModule'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import ShouninTaskCard from '../molecules/ShouninTaskCard.vue'

@Component({
  components: { TcwLayoutBasicTemplate, ShouninTaskCard }
})
export default class ShouninList extends Mixins(BasePage) {
  protected fastForward = false

  protected get shouninTasks(): ShouninTask[] {
    return shouninTaskStore.get
  }

  protected mounted(): void {
    this.loadShouninTasks()
  }

  protected async loadShouninTasks(): Promise<void> {
    this.isLoading = true
    const tasks = await shouninTaskStore.fetch()

    // １件の場合はパラメータによってそのまま承認画面へ遷移する
    if (tasks.length === 1 && this.routeParams.fast === 'fast') {
      const task = tasks[0]
      this.$router.push(
        `/teishutsu/${task.getsudo.yearValue}/${task.getsudo.monthValue}/${task.teishutsushaId}`
      )
    }
    this.isLoading = false
  }
}
